import(/* webpackMode: "eager" */ "/app/src/app/(app)/[locale]/error.tsx");
